import { render, staticRenderFns } from "./Clean.vue?vue&type=template&id=545b65d6&scoped=true&"
import script from "./Clean.vue?vue&type=script&lang=js&"
export * from "./Clean.vue?vue&type=script&lang=js&"
import style0 from "./Clean.vue?vue&type=style&index=0&id=545b65d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545b65d6",
  null
  
)

export default component.exports